import * as Yup from 'yup'
import { z, z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const OrdersWestfieldConsDefaultSchemas = DefaultSchemas

const OrdersWestfieldConsDetailsCardsDataSchemas = zod.object({
  traderId: zod.number(),
  traderTransIdent: zod.string(),
})

const OrdersWestfieldConsDetailsDataSchemas = zod.object({
  detailId: zod.string(),
  value: zod.number(),
  quantity: zod.number(),
  productName: zod.number(),
  cards: zod.array(OrdersWestfieldConsDetailsCardsDataSchemas),
})

export const OrdersWestfieldConsDataSchemas = zod.object({
  orderId: zod.number(),
  orderDate: zod.string(),
  trackNumber: zod.number().nullable(),
  trackingStatus: zod.string(),
  trackingStatusId: zod.number(),
  amount: zod.number(),
})

export const OrdersWestfieldConsAPISchemas =
  OrdersWestfieldConsDefaultSchemas.merge(
    zod.object({
      data: zod.array(OrdersWestfieldConsDataSchemas),
    })
  )

export const OrdersWestfieldConsFetchParamsSchemas = zod.object({
  enrolmentTraderId: zod.number().optional().nullable(),
  traderId: zod.number().optional().nullable(),
  orderId: zod.number().optional().nullable(),
  traderName: zod.string().optional().nullable(),
  startDate: zod.string().optional(),
  endDate: zod.string().optional(),
  orderStatusId: zod.number().optional().nullable(),
})

export const OrdersWestfieldConsUpdateParamsSchemas = zod.object({
  traderId: zod.number(),
  noteId: zod.number(),
  noteTypeId: zod.string(),
  priorityLevel: zod.string(),
  noteDescription: zod.string(),
  creationDate: zod.string(),
  sourceName: zod.string(),
})
